import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { CheckoutSessionCommunity } from "@circle-react/types/Paywalls/Checkout/Session";

import { Content } from "./Content";

interface CommunityHeaderProp {
  className?: string;
  community: Pick<CheckoutSessionCommunity, "name" | "icon_url" | "logo_url">;
}

export const CommunityHeader = ({
  className,
  community,
}: CommunityHeaderProp) => (
  <div
    className={classNames(
      "flex flex-row justify-center py-[1.625rem] md:py-[2.625rem] lg:justify-start lg:py-10",
      className,
    )}
  >
    <Content community={community} />
  </div>
);
